export default __webpack_public_path__ + "static/article-wedding-how-to-tackle-your-wedding-finance-jitters-c63b2e1db019a91953dbadc6e1960a40.jpg";